<template>
    <main class="review-page">
        <header class="review-header">
            <button type="button" class="back-button" aria-label="返回" @click="goBack">
                <a-icon type="left"/>
            </button>
            <h1>发布评价</h1>
            <span class="header-placeholder"></span>
        </header>

        <div v-if="loadError" class="review-error">
            <a-icon type="exclamation-circle"/>
            <strong>评价内容加载失败</strong>
            <span>{{ loadError }}</span>
        </div>

        <a-spin v-else :spinning="loading" class="review-loading">
            <div class="review-content">

                <section class="share-copy-card">
                    <div class="share-section-heading">
                        <strong>评价文案</strong>
                    </div>
                    <p class="generated-review-text" :class="{'is-exhausted': reviewExhausted}">
                        {{ reviewExhausted ? 'AI生成次数已用完' : displayedReviewText }}<span v-if="typingReview" class="typing-cursor"
                                                       aria-hidden="true"></span>
                    </p>
                    <div v-if="!reviewExhausted" class="share-copy-footer">
                        <a href="#" :class="{disabled: loading || typingReview}" @click.prevent="replaceReview">
                            {{ loading ? '正在更换' : (typingReview ? '正在生成' : '换一换') }}
                        </a>
                    </div>
                </section>


                <section class="review-action-guide review-action-guide-top"
                         v-if="!(loading || typingReview || Boolean(loadError) || reviewExhausted)">
                    <Icon name="checked" size="16px" color="#11910b"/>
                    <span>文案已复制，{{ openButtonText }}并粘贴评价</span>
                </section>

                <!--                <section class="review-action-guide">-->
                <!--                    <strong style="font-size: 20px">操作提示：</strong>-->
                <!--                    <span style="color: red;font-size: 20px">点击底部左侧复制按钮，再{{-->
                <!--                        openButtonText-->
                <!--                        }}，粘贴评价文案</span>-->
                <!--                </section>-->
            </div>
        </a-spin>

        <footer class="review-actions" style="display: flex;justify-content: center">
            <!--            <div class="review-action-buttons">-->
            <!--                <div class="copy-action-wrap">-->
            <!--                    <button-->
            <!--                            type="button"-->
            <!--                            class="action-button copy-button"-->
            <!--                            :disabled="loading || Boolean(loadError)"-->
            <!--                            @click="copyShareText"-->
            <!--                    >-->
            <!--                        &lt;!&ndash;                <span class="action-step" aria-hidden="true">1</span>&ndash;&gt;-->
            <!--                        复制文案-->
            <!--                    </button>-->
            <!--                </div>-->
            <button
                    type="button"
                    class="action-button open-button"
                    style="width: 100%;"
                    :class="platformClass"
                    :disabled="loading || typingReview || Boolean(loadError)"
                    @click="openShareTarget"
            >
                <!--                <span class="action-step" aria-hidden="true">2</span>-->
                {{ openButtonText }}
            </button>
            <!--            </div>-->

        </footer>

    </main>
</template>

<script>
import {Toast, Icon} from 'vant';
import 'vant/lib/toast/style';
import {
    drawReviewContent,
    getPublicH5Page,
    getPublicReviewTopics,
    markReviewUsed
} from '../../api/h5Page';

const REVIEW_STORAGE_KEY = 'ai-video-review-content';
const UNCLASSIFIED_TOPIC_ID = 'UNCLASSIFIED';
const RANDOM_TOPIC_ID = 'RANDOM';
const resolveReviewContentType = itemType => (
    itemType === 'XIAOHONGSHU_PLANTING' ? 'recommend' : 'review'
);

export default {
    name: 'ReviewPage',
    components: {
        Icon
    },
    data() {
        return {
            loading: false,
            typingReview: false,
            displayedReviewText: '',
            reviewTypingTimer: null,
            reviewTypingRunId: 0,
            loadError: '',
            reviewExhausted: false,
            reviewTopics: [],
            reviewConfig: {
                itemType: '',
                targetUrl: '',
                appTargetUrl: '',
                description: '',
                plateNo: ''
            },
            currentReview: {
                id: '',
                title: '',
                content: '',
                topicId: '',
                topicName: '',
                reviewCounted: false
            }
        };
    },
    created() {
        this.loadReviewPage();
    },
    beforeDestroy() {
        this.stopReviewTyping();
    },
    computed: {
        shareText() {
            return String(this.currentReview.content || this.currentReview.title || '').trim();
        },
        openButtonText() {
            return {
                DOUYIN_REVIEW: '打开抖音',
                MEITUAN_REVIEW: '打开美团',
                DIANPING_REVIEW: '打开大众点评',
                GAODE_REVIEW: '打开高德地图'
            }[this.reviewConfig.itemType] || '打开';
        },
        platformClass() {
            return {
                MEITUAN_REVIEW: 'meituan',
                DIANPING_REVIEW: 'dianping',
                GAODE_REVIEW: 'gaode'
            }[this.reviewConfig.itemType] || 'douyin';
        }
    },
    methods: {
        async loadReviewPage() {
            const plateNo = String(this.$route.query.sn || '').trim();
            const itemType = String(this.$route.query.type || '').trim();
            const topicId = String(this.$route.query.topicId || '').trim();
            if (!plateNo || !itemType) {
                this.loadError = '缺少评价页面参数';
                return;
            }
            if (!topicId) {
                await this.$router.replace({path: '/app/review', query: {sn: plateNo, type: itemType}});
                return;
            }

            this.loading = true;
            try {
                this.reviewConfig = await this.resolveReviewConfig(plateNo, itemType);
                this.reviewTopics = await getPublicReviewTopics(plateNo);
                const selectedTopic = topicId === UNCLASSIFIED_TOPIC_ID
                    ? null
                    : this.reviewTopics.find(topic => String(topic.id) === topicId);
                if (![UNCLASSIFIED_TOPIC_ID, RANDOM_TOPIC_ID].includes(topicId) && !selectedTopic) {
                    throw new Error('所选评价主题不存在或已停用');
                }
                await this.drawReview(selectedTopic, '', topicId === RANDOM_TOPIC_ID);
            } catch (error) {
                this.loadError = error.message || '无法获取评价内容';
            } finally {
                this.loading = false;
            }
        },
        async resolveReviewConfig(plateNo, itemType) {
            try {
                const cached = JSON.parse(window.sessionStorage.getItem(REVIEW_STORAGE_KEY) || 'null');
                if (cached && cached.plateNo === plateNo && cached.itemType === itemType) {
                    return cached;
                }
            } catch (error) {
                window.sessionStorage.removeItem(REVIEW_STORAGE_KEY);
            }

            const pageConfig = await getPublicH5Page(plateNo, true);
            const groups = Array.isArray(pageConfig.groups) ? pageConfig.groups : [];
            const items = groups.reduce((result, group) => (
                result.concat(Array.isArray(group.items) ? group.items : [])
            ), []);
            const item = items.find(candidate => candidate.itemType === itemType);
            if (!item) throw new Error('未找到对应评价入口');
            const params = item.params || {};
            return {
                itemType,
                targetUrl: params.targetUrl || '',
                appTargetUrl: params.appTargetUrl || '',
                description: String(item.description || '').trim(),
                plateNo
            };
        },
        async drawReview(topic, excludeReviewId, randomAll = false) {
            const result = await drawReviewContent(
                this.reviewConfig.plateNo,
                this.reviewConfig.itemType,
                resolveReviewContentType(this.reviewConfig.itemType),
                topic ? topic.id : undefined,
                excludeReviewId || undefined,
                randomAll
            );
            const review = result || {};
            this.currentReview = {
                id: review.id || '',
                title: review.title || '',
                content: review.content || '',
                topicId: randomAll ? RANDOM_TOPIC_ID : (topic ? topic.id : ''),
                topicName: randomAll ? '随机评价' : (topic ? topic.topicName : ''),
                reviewCounted: false
            };
            this.reviewExhausted = !this.currentReview.id || !this.shareText;
            if (this.reviewExhausted) {
                this.stopReviewTyping();
                this.displayedReviewText = '';
                return;
            }
            this.startReviewTyping(this.shareText);
        },
        startReviewTyping(text) {
            this.stopReviewTyping();
            const characters = Array.from(String(text || ''));
            if (!characters.length) {
                this.displayedReviewText = '';
                return;
            }

            const runId = ++this.reviewTypingRunId;
            let currentIndex = 0;
            const typingCharacterCount = Math.min(characters.length, 20);
            this.displayedReviewText = '';
            this.typingReview = true;

            const revealNextCharacter = () => {
                if (runId !== this.reviewTypingRunId) return;
                currentIndex += 1;
                this.displayedReviewText = characters.slice(0, currentIndex).join('');
                if (currentIndex >= typingCharacterCount) {
                    // 前 20 个字逐字展示后，立即补齐剩余文案。
                    this.displayedReviewText = characters.join('');
                    this.typingReview = false;
                    this.reviewTypingTimer = null;
                    return;
                }

                // 在标点和换行处稍作停顿，模拟 AI 分句生成的节奏。
                const currentCharacter = characters[currentIndex - 1];
                const delay = currentCharacter === '\n'
                    ? 180
                    : (/[，。！？；：,.!?;:]/.test(currentCharacter) ? 85 : 28);
                this.reviewTypingTimer = window.setTimeout(revealNextCharacter, delay);
            };
            this.reviewTypingTimer = window.setTimeout(revealNextCharacter, 120);
        },
        stopReviewTyping() {
            this.reviewTypingRunId += 1;
            if (this.reviewTypingTimer) {
                window.clearTimeout(this.reviewTypingTimer);
                this.reviewTypingTimer = null;
            }
            this.typingReview = false;
        },
        async replaceReview() {
            if (this.loading || this.typingReview) return;
            const topic = this.reviewTopics.find(item => item.id === this.currentReview.topicId) || null;
            const randomAll = this.currentReview.topicId === RANDOM_TOPIC_ID;
            this.loading = true;
            try {
                await this.drawReview(topic, this.currentReview.id, randomAll);
            } catch (error) {
                Toast.fail(error.message || '评价文案获取失败');
            } finally {
                this.loading = false;
            }
        },
        async copyShareText() {
            if (!this.shareText) return;
            try {
                await this.copyTextToClipboard(this.shareText);
                Toast.success('内容已复制');
            } catch (error) {
                Toast.fail('复制失败，请长按内容复制');
            }
        },
        async copyTextToClipboard(text) {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(text);
                return;
            }
            const input = document.createElement('textarea');
            input.value = text;
            input.setAttribute('readonly', 'readonly');
            input.style.position = 'fixed';
            input.style.opacity = '0';
            document.body.appendChild(input);
            input.select();
            let copied = false;
            try {
                copied = document.execCommand('copy');
            } finally {
                document.body.removeChild(input);
            }
            if (!copied) throw new Error('copy failed');
        },
        async openShareTarget() {
            if (this.shareText) {
                try {
                    // 有文案时先复制；文案用尽时跳过复制，继续打开第三方平台。
                    await this.copyTextToClipboard(this.shareText);
                } catch (error) {
                    Toast.fail('复制失败，请先点击左侧复制文案');
                    return;
                }
            }
            if (this.currentReview.id && !this.currentReview.reviewCounted) {
                try {
                    await markReviewUsed(
                        this.reviewConfig.plateNo,
                        this.currentReview.id,
                        this.reviewConfig.itemType,
                        resolveReviewContentType(this.reviewConfig.itemType)
                    );
                    this.currentReview.reviewCounted = true;
                } catch (error) {
                    Toast.fail(error.message || '评价使用次数记录失败，请重试');
                    return;
                }
            }
            const normalizedUrl = this.extractFirstHttpUrl(this.reviewConfig.targetUrl);
            const targetUrl = this.reviewConfig.itemType === 'DOUYIN_REVIEW' && this.isMobileBrowser()
                ? String(this.reviewConfig.appTargetUrl || '').trim() || normalizedUrl
                : normalizedUrl;
            if (!targetUrl) {
                Toast.fail('商户暂未配置该功能的跳转地址');
                return;
            }
            if (this.reviewConfig.itemType === 'DOUYIN_REVIEW' && this.isRestrictedInAppBrowser()) {
                // 在微信内进入独立引导页，改用系统浏览器后直接继续抖音跳转。
                await this.$router.push({
                    path: '/app/browser-open-guide',
                    query: {platform: '抖音', target: targetUrl}
                });
                return;
            }
            window.location.href = targetUrl;
        },
        extractFirstHttpUrl(targetUrl) {
            const normalizedUrl = String(targetUrl || '').trim();
            const httpUrlMatch = normalizedUrl.match(/^https?:\/\/\S+/i);
            return httpUrlMatch ? httpUrlMatch[0] : normalizedUrl;
        },
        isMobileBrowser() {
            return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '');
        },
        isRestrictedInAppBrowser() {
            return /MicroMessenger|QQ\/|Weibo|DingTalk|AlipayClient/i.test(navigator.userAgent || '');
        },
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
                return;
            }
            this.$router.replace({path: '/app', query: {sn: this.reviewConfig.plateNo}});
        }
    }
};
</script>

<style scoped>
.review-page {
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    padding-bottom: calc(88px + env(safe-area-inset-bottom));
    color: #1f2937;
    background: #f5f6f8;
}

.review-header {
    position: sticky;
    z-index: 10;
    top: 0;
    display: grid;
    height: 52px;
    align-items: center;
    grid-template-columns: 42px 1fr 42px;
    padding: 0 10px;
    border-bottom: 1px solid #eceef2;
    background: rgba(255, 255, 255, .96);
    backdrop-filter: blur(12px);
}

.review-header h1 {
    margin: 0;
    font-size: 18px;
    font-weight: 650;
    text-align: center;
}

.back-button {
    width: 38px;
    height: 38px;
    border: 0;
    color: #374151;
    background: transparent;
    font-size: 17px;
}

.review-loading,
.review-loading /deep/ .ant-spin-container {
    min-height: calc(100vh - 140px);
    min-height: calc(100dvh - 140px);
}

.review-content {
    padding: 16px 16px 28px;
}

.share-copy-card,
.review-action-guide,
.review-description {
    padding: 16px;
}

.share-copy-card {
    border: 1px solid #eef0f3;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 8px 24px rgba(31, 41, 55, .055);
}

.review-action-guide-top {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 12px;
    padding: 11px 14px;
    border-radius: 10px;
    color: #11910b;
    background: #b2f3b0;
    font-size: 13px;
    font-weight: 600;
}

.share-copy-card + .review-action-guide,
.review-action-guide + .review-description {
    margin-top: 12px;
}

.share-section-heading strong,
.review-description strong {
    font-size: 15px;
    font-weight: 650;
}

.share-section-heading {
    margin-bottom: 10px;
}

.share-copy-card p {
    margin: 0;
    color: #344054;
    font-size: 15px;
    line-height: 1.8;
    white-space: pre-wrap;
    word-break: break-word;
}

.generated-review-text {
    min-height: 54px;
}

.generated-review-text.is-exhausted {
    color: #98a2b3;
    text-align: center;
}

.typing-cursor {
    display: inline-block;
    width: 2px;
    height: 1.15em;
    margin-left: 3px;
    border-radius: 1px;
    background: #2878df;
    vertical-align: -.18em;
    animation: typing-cursor-blink .75s steps(1) infinite;
}

@keyframes typing-cursor-blink {
    50% {
        opacity: 0;
    }
}

.share-copy-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
}

.share-copy-footer a {
    color: #2878df;
    font-size: 14px;
}

.share-copy-footer a.disabled {
    color: #aeb5bf;
    pointer-events: none;
}

.review-action-guide {
//color: #667085; font-size: 13px; line-height: 1.6;
}

.review-action-guide strong {
    color: #344054;
}

.review-description p {
    margin: 8px 0 0;
    color: #667085;
    font-size: 13px;
    line-height: 1.7;
    white-space: pre-wrap;
}

.review-actions {
    position: fixed;
    z-index: 20;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
    border-top: 1px solid #e7e9ed;
    background: rgba(255, 255, 255, .96);
    box-shadow: 0 -5px 20px rgba(31, 41, 55, .06);
    backdrop-filter: blur(12px);
}

.review-action-buttons {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
}

.copy-action-wrap {
    position: relative;
}

.copy-action-wrap .copy-button {
    width: 100%;
}

.action-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    height: 50px;
    border: 0;
    border-radius: 10px;
    font-family: inherit;
    font-size: 16px;
    font-weight: 600;
}

.action-step {
    display: inline-flex;
    width: 18px;
    height: 18px;
    align-items: center;
    justify-content: center;
    flex: 0 0 18px;
    border: 2px solid currentColor;
    border-radius: 50%;
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
}

.copy-button {
    color: #004eab;
    background: #eaf3ff;
}

.open-button {
    color: #fff;
    background: #111827;
}

.open-button.meituan {
    color: #242424;
    background: #ffdf00;
}

.open-button.dianping {
    background: #ff6a00;
}

.open-button.gaode {
    background: #1677ff;
}

.action-button:disabled {
    opacity: .5;
}

.review-error {
    display: flex;
    min-height: calc(100vh - 140px);
    min-height: calc(100dvh - 140px);
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 32px;
    color: #8b95a5;
    text-align: center;
}

.review-error .anticon {
    color: #c3c9d1;
    font-size: 42px;
}

.review-error strong {
    margin-top: 16px;
    color: #374151;
    font-size: 18px;
}

.review-error span {
    margin-top: 8px;
    font-size: 13px;
}

@media (min-width: 520px) {
    .review-page {
        width: 430px;
        margin: 0 auto;
        box-shadow: 0 0 50px rgba(25, 48, 83, .12);
    }

    .review-actions {
        right: auto;
        left: 50%;
        width: 430px;
        transform: translateX(-50%);
    }
}
</style>
